import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "002_tenant_providers",
  version: "1.0.1",
  sql: `
CREATE TABLE IF NOT EXISTS \`ai_tenant_providers\` (
  \`id\` text PRIMARY KEY NOT NULL,
  \`provider\` text NOT NULL,
  \`api_key\` text,
  \`account_id\` text,
  \`is_enabled\` integer DEFAULT 0 NOT NULL,
  \`created_at\` text NOT NULL,
  \`created_by\` text,
  \`updated_at\` text NOT NULL,
  \`updated_by\` text,
  \`last_test_status\` text,
  \`last_tested_at\` text
);
ALTER TABLE \`ai_tenant_providers\` ADD COLUMN \`last_test_status\` text;
ALTER TABLE \`ai_tenant_providers\` ADD COLUMN \`last_tested_at\` text;
CREATE UNIQUE INDEX IF NOT EXISTS \`idx_ai_tenant_providers_provider\` ON \`ai_tenant_providers\` (\`provider\`);
CREATE INDEX IF NOT EXISTS \`idx_ai_tenant_providers_enabled\` ON \`ai_tenant_providers\` (\`is_enabled\`);
  `.trim(),
};
